define(
	'Tavanoteam.TavanoTeam_Fonts_Extension.Fonts',
	[],
	function () {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var environment = container.getComponent("Environment");
				var loadFonts = environment.getConfig('tavanoTeamFontsExtension.enabled');
				var googleFamilies = environment.getConfig('tavanoTeamFontsExtension.googleFamilies') || {};

				/* Google async Fonts */
				if (loadFonts && (googleFamilies.length > 0) && environment.getConfig('tavanoTeamFontsExtension.async')) {
					window.WebFontConfig = {
						google: {
							families: googleFamilies
						}
					};

					if (SC.ENVIRONMENT.jsEnvironment === 'browser') {
						(function (d) {
							var f = d.createElement('script'), s = d.scripts[0];
							f.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://ajax.googleapis.com/ajax/libs/webfont/1.5.18/webfont.js';
							f.type = 'text/javascript';
							f.async = 'true';
							s.parentNode.insertBefore(f, s);
						})(document);
					}
				}

				/* Custom Fonts */
				var newStyle = document.createElement('style');
				var customFontsStyles = "";
				var customFonts = environment.getConfig('tavanoTeamFontsExtension.customFamilies');

				if (loadFonts && !!customFonts) {
					if (customFonts.length > 0) {

						/* Create all '@font-face' */
						for (var i = 0; i < customFonts.length; i++) {
							var mergeWeights = "";

							/* Merge weights */
							for (var j = 0; j < customFonts.length; j++) {
								if (i != j && customFonts[i].fontfamily === customFonts[j].fontfamily && customFonts[i].src === customFonts[j].src && customFonts[i].fontstyle === customFonts[j].fontstyle) {
									if (customFonts[i].fontweight != customFonts[j].fontweight) {
										mergeWeights += "," + customFonts[j].fontweight;
									}
									customFonts[j] = false;
								}
							}

							if (!!customFonts[i]) {
								customFontsStyles += "@font-face{";
								customFontsStyles += "font-family: '" + customFonts[i].fontfamily + "';";
								customFontsStyles += "src: url(" + customFonts[i].src + ")" + (customFonts[i].format != "" ? " format('" + customFonts[i].format + "')" : "") + ";";
								customFontsStyles += "font-weight: " + customFonts[i].fontweight + mergeWeights + ";";
								customFontsStyles += "font-style: " + customFonts[i].fontstyle + ";";
								customFontsStyles += "font-display: swap;";
								customFontsStyles += "}";
							}
						}

						newStyle.appendChild(document.createTextNode(customFontsStyles));

						document.head.appendChild(newStyle);
					}
				}
			}
		};
	}
);
